// extracted by mini-css-extract-plugin
export default {"accordion":"CAccordion_accordion__DVuaO","accordionToggle":"CAccordion_accordionToggle__PW9Df","panel":"CAccordion_panel__1gDC0","show":"CAccordion_show__lTbUa"};